import { AxiosResponse } from "axios";
import client from "../client";
import { getTemplatesConfig } from "./getTemplatesConfig";
import { handleAxiosError } from "@/utils/apiErrorHandler";
import { TemplatesData } from "@/data/types/templates";

export const getTemplatesService = async ({
  authorization,
  queryParamsString,
}: {
  authorization: string;
  queryParamsString?: string;
}): Promise<AxiosResponse<TemplatesData>> => {
  if (!authorization) {
    throw new Error("Authentication token is required for fetching templates.");
  }

  try {
    const response = await client(getTemplatesConfig(authorization, queryParamsString));
    return response;
  } catch (error: any) {
    handleAxiosError(error);
  }
};
